export default __webpack_public_path__ + "static/07-52060e77fbe2fb51fed006f230fdf1e8.jpg";